import { Select, TextField } from '@cimpress/react-components';
import DatePicker from '@cimpress/react-components/lib/DatePicker';
import { useEffect, useState } from 'react';
import { getLocationsAndFulfillersData } from '../../../services/fulfillers';
import LocationDetailsCard from './LocationDetailsCard';
import { showSnackbar } from '../../../redux/actions/snackbarActions';
import { useDispatch } from 'react-redux';

const DelayBySection = ({ schedule = {}, setSchedule, disabled = false }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationDetails, setLocationDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchLocationsAndFulfillers = async () => {
      setIsLoading(true);
      try {
        const locationList = await getLocationsAndFulfillersData();
        setLocationDetails(locationList);
      } catch (error) {
        dispatch(
          showSnackbar({
            message: `Failed to fetch Fulfiller / Locations : ${JSON.stringify(error)}`,
            style: 'danger',
          }),
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchLocationsAndFulfillers();
  }, [dispatch]);

  const handleOptionChange = selectedLocation => {
    setSelectedLocation(selectedLocation);
    if (selectedLocation) {
      setSchedule(schedule => ({
        ...schedule,
        fulfillmentLocationId: selectedLocation.value?.fulfillmentLocationId,
      }));
    }
  };

  const delayUnitOptions = {
    HH: { value: 'HH', label: 'Hours' },
    DD: { value: 'DD', label: 'Days' },
  };

  return (
    <div style={{ marginTop: '10px' }}>
      <p style={{ marginBottom: '16px' }}>
        Setup the duration for which the delay will be added to current production time
      </p>
      <div className='flex-row'>
        <div className='delay-time-text'>
          <TextField
            label='Delay Time'
            value={schedule.delayTime}
            onChange={e => setSchedule?.({ ...schedule, delayTime: e.target.value })}
            type='number'
            required
            disabled={disabled}
          />
        </div>
        <div className='delay-unit-select'>
          <Select
            label='Unit'
            value={delayUnitOptions[schedule.delayUnit] || null}
            options={Object.values(delayUnitOptions)}
            onChange={e => setSchedule?.({ ...schedule, delayUnit: e.value })}
            required
            isDisabled={disabled}
          />
        </div>
      </div>
      <p style={{ marginBottom: '16px' }}>Specify the start and end date and time for the above delay duration</p>
      <div className='flex-column'>
        <div className='flex-row-wrap'>
          <div style={{ marginRight: '16px' }} className='remove-margins-paddings'>
            <DatePicker
              label='Start'
              dateFormat='Y-MM-DD'
              value={schedule.startDate}
              closeOnClickOutside={true}
              closeOnSelect={true}
              isClearable={!disabled}
              onChange={d => {
                setSchedule?.({ ...schedule, startDate: d ? new Date(d).toISOString() : undefined });
              }}
              required
              disabled={disabled}
            />
          </div>
          <div className='remove-margins-paddings'>
            <DatePicker
              label='End'
              dateFormat='Y-MM-DD'
              value={schedule.endDate}
              closeOnClickOutside={true}
              closeOnSelect={true}
              isClearable={!disabled}
              onChange={d => setSchedule?.({ ...schedule, endDate: d ? new Date(d).toISOString() : undefined })}
              required
              disabled={disabled}
            />
          </div>
        </div>
        <div style={{ width: '620px' }}>
          <Select
            isLoading={isLoading}
            isClearable
            label='Select a location'
            value={selectedLocation}
            options={locationDetails?.map(({ fulfillerName, location, fulfillmentLocationId }) => ({
              value: { fulfillerName, location, fulfillmentLocationId },
              label: `${fulfillerName} - ${location}(${fulfillmentLocationId})`,
            }))}
            onChange={handleOptionChange}
          />
          {selectedLocation && <LocationDetailsCard selectedLocation={selectedLocation} />}
        </div>
      </div>
    </div>
  );
};

export default DelayBySection;
